export default {
  id: 'CreateStudentModal',
  code: 'CN',
  text: {
    'Student Name': '学员姓名',
    'Gender': '学员性别',
    'DOB': '学员生日',
    'Phone': '学员电话',
    'Email': '学员邮箱',
    'Preferred Name': '学员昵称',
    'Created On': '注册时间',
    'Address': '现居地址',
    'Remarks': '备注',
    'Primary Guardian': '家长1',
    'Secondary Guardian': '家长2',
    'New Student': '新增学员',
    'Student Photo': '学员头像',

    'Basic Info': '基本信息',
    'Other Info': '其他信息',
    '': '',
    'Student can use phone number to sign up and log in mobile app': '学生将可以使用手机号注册登录手机 app',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/CreateStudent/locale.js